const factory = [
  {
    path: "/factory/manage",
    name: "factoryManage",
    component: () => import("@/view/factory/manage"),
  },
  {
    path: "/factory/project",
    name: "factoryProject",
    component: () => import("@/view/factory/projectInfo"),
  },
  {
    path: "/factory/performance",
    name: "factoryPerformance",
    component: () => import("@/view/factory/performance"),
  },
  {
    path: "/factory/auditor",
    name: "factoryAuditor",
    component: () => import("@/view/factory/auditor"),
  },
  {
    path: "/factory/sysConfig",
    name: "factorySysConfig",
    component: () => import("@/view/factory/sysConfig"),
  },
];
export default factory;
